import React, {useState, useEffect, useMemo} from 'react';
import useApiControl from './common/useApiControl';
import { Box, Button, useMediaQuery } from '@mui/material';

import BaseHeader from './components/headers/BaseHeader';
import RoomHeader from './components/headers/RoomHeader';
import NotLoginHeader from './components/headers/NotLoginHeader';
import TopList from './components/eventList/TopList';
import DailyPointClaimedDialog from './components/dialogs/DailyPointClaimedDialog';
import GuestRegisterDialog from './components/dialogs/GuestRegisterDialog';
import NameSetupDialog from './components/dialogs/NameSetupDialog';
import TopWhatGame from './components/top/TopWhatGame';
import {
  clearQuickJoinNameSetup,
  dismissQuickJoinNameSetup,
  shouldPromptQuickJoinNameSetup,
} from './common/quickJoinNameSetup';

const betaTestPath = '/event/2026-beta';

const BetaTestLink = ({ mobile }) => (
  <Box
    sx={{
      mx: mobile ? 1.5 : { xs: 1.5, md: 3 },
      mt: mobile ? 1 : 1.5,
      mb: mobile ? 1.5 : 2,
      p: { xs: 1.75, sm: 2 },
      borderRadius: '16px',
      border: '1px solid rgba(25, 118, 210, 0.24)',
      background: 'linear-gradient(135deg, rgba(227, 242, 253, 0.98) 0%, rgba(255, 255, 255, 0.96) 100%)',
      display: 'flex',
      alignItems: { xs: 'stretch', sm: 'center' },
      justifyContent: 'space-between',
      gap: 1.5,
      flexDirection: { xs: 'column', sm: 'row' },
      boxSizing: 'border-box',
    }}
  >
    <Box>
      <Box sx={{ fontSize: '16px', fontWeight: 900, color: '#0f2a5f', mb: 0.5 }}>
        betty ベータテスト開催中
      </Box>
      <Box sx={{ fontSize: '13px', lineHeight: 1.6, color: 'rgba(15, 42, 95, 0.76)' }}>
        参加方法・スケジュール・注意事項はこちらから確認できます。
      </Box>
    </Box>
    <Button
      href={betaTestPath}
      variant="contained"
      sx={{
        minWidth: { xs: '100%', sm: 168 },
        borderRadius: '999px',
        fontWeight: 800,
        boxShadow: 'none',
      }}
    >
      ベータテストページへ
    </Button>
  </Box>
);

function Top() 
{
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [events, setEvents] = useState(); // イベント一覧情報
  const [makeEvents, setMakeEvents] = useState();
  const [joinEvents, setJoinEvents] = useState();
  const [followMakeEvents, setFollowMakeEvents] = useState();
  const [followJoinEvents, setFollowJoinEvents] = useState();
  const [rivalsJoinEvents, setRivalsJoinEvents] = useState();
  const [masterTags, setMasterTags] = useState([]);



  const [isLogin, setIsLogin] = useState(null); // ログイン状態
  const [user, setUser] = useState(null);
  const [dailyPointMessage, setDailyPointMessage] = useState('');
  const [dailyPointDialogMessage, setDailyPointDialogMessage] = useState('');
  const [isDailyPointDialogVisible, setIsDailyPointDialogVisible] = useState(false);
  const [isGuestRegisterDialogVisible, setIsGuestRegisterDialogVisible] = useState(false);
  const [isNameSetupDialogVisible, setIsNameSetupDialogVisible] = useState(false);
  const [nameSetupMessage, setNameSetupMessage] = useState('');

  //login
  const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
      action: '/is_login',
      params: '',
      method: 'POST',
  });  

  //login
  useEffect(() => {
      // 自分がログイン済みかチェック
      executeRequest1().catch((error) => {
          console.error(error);
          setIsLogin(false);
          // setExceptionOccurred4(true);
      });
  }, []);

  useEffect(() => {
      if (data1) {
        setIsLogin(data1.is_login);
      }
  }, [data1]);

  useEffect(() => {
    if (isLogin === false) {
      setIsGuestRegisterDialogVisible(true);
    }
  }, [isLogin]);

    //user
  const { data: data2, loading: loading2, executeRequest: executeRequest2 } = useApiControl({
    action: '/get_user',
    method: 'POST',
  });

  const updateUser = () => {
    executeRequest2().catch((error) => {
        console.error(error);
        // setExceptionOccurred(true);
    });
  };

  useEffect(() => {
    if(isLogin) {
      updateUser();
    }
  }, [isLogin]);

  useEffect(() => {
    if (data2) {
      setUser(data2);
      localStorage.setItem('user', JSON.stringify(data2));
    }
  }, [data2]);

  const handleGuestRegistered = (response) => {
    if (response?.user) {
      setUser(response.user);
    }

    setIsLogin(true);
    updateUser();
  };

  const { loading: claimingDailyPoint, executeRequest: executeRequestDailyPoint } = useApiControl({
    action: '/claim_daily_point',
    method: 'POST',
  });
  const { loading: updatingName, executeRequest: executeUpdateName } = useApiControl({
    action: '/update_user',
    method: 'POST',
  });

  useEffect(() => {
    if (isLogin && user && shouldPromptQuickJoinNameSetup(user)) {
      setNameSetupMessage('');
      setIsNameSetupDialogVisible(true);
    }
  }, [isLogin, user]);

  const closeNameSetupDialogForLater = () => {
    dismissQuickJoinNameSetup(user);
    setIsNameSetupDialogVisible(false);
    setNameSetupMessage('');
  };

  const saveNameSetup = (name) => {
    setNameSetupMessage('');
    executeUpdateName({ name })
      .then((response) => {
        const updatedUser = response?.user ?? { ...user, name };
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
        clearQuickJoinNameSetup(updatedUser);
        setIsNameSetupDialogVisible(false);
        updateUser();
      })
      .catch((error) => {
        console.error(error);
        const validationName = error.response?.data?.errors?.name;
        setNameSetupMessage(
          Array.isArray(validationName)
            ? validationName[0]
            : error.response?.data?.message || '表示名を保存できませんでした。'
        );
      });
  };

  const claimDailyPoint = () => {
    const claimedDailyPointAmount = user?.daily_point_amount;
    setDailyPointMessage('');
    executeRequestDailyPoint().then((response) => {
      if (response?.user) {
        setUser(response.user);
      } else {
        updateUser();
      }
      setDailyPointDialogMessage(
        response?.message || (
          claimedDailyPointAmount
            ? `参加チケット ${claimedDailyPointAmount}枚を受け取りました。`
            : '参加チケットを受け取りました。'
        )
      );
      setIsDailyPointDialogVisible(true);
    }).catch((error) => {
      console.error(error);
      setDailyPointMessage('参加チケットの受取に失敗しました。');
    });
  };

  const params3 = useMemo(() => ({
    // ownerIds: [1],
    // ownerName: 'name',
  }), []);

//   $rules = [
//     'tag' => 'nullable|integer',
//     'ownerName' => 'nullable|string',
//     'eventName' => 'nullable|string',
//     'limit' => 'nullable|integer|min:1|max:100',
//     'orderDir' => 'nullable|string|in:asc,desc',
// ];

  //events全体
  const { data: data3, loading: loading3, executeRequest: executeRequest3 } = useApiControl({
      action: '/get_events',
      params: params3,
      method: 'POST',
  });  

  //events
  useEffect(() => {
    console.log(`[${new Date().toISOString()}] get_events start`);
      executeRequest3().catch((error) => {
          console.error(error);
          // setExceptionOccurred4(true);
      });
  }, []);

  useEffect(() => {
      if (data3) {
        setEvents(data3.events);
      }
  }, [data3]);

  // follow user owners events
  const params4 = useMemo(function() {
    if (user?.follow && user.follow !== "[]") {
      return {
        ownerIds: JSON.parse(user.follow)
      }
    } 
  }, [user?.follow]);

  const { data: data4, loading: loading4, executeRequest: executeRequest4 } = useApiControl({
    action: '/get_events',
    params: params4,
    method: 'POST',
  });

  useEffect(() => {
    if (params4 && params4.ownerIds && params4.ownerIds.length) {
      executeRequest4().catch((error) => {
        console.error(error);
      });
    }
  }, [params4]);

  useEffect(() => {
      if (data4) {
        setFollowMakeEvents(data4.events);
      }
  }, [data4]);

  // follow user join events
  const params5 = useMemo(function() {
    if (user?.follow && user.follow !== "[]") {
      return {
        userIds: JSON.parse(user.follow)
      }
    } 
  }, [user?.follow]);

  const { data: data5, loading: loading5, executeRequest: executeRequest5 } = useApiControl({
    action: '/get_join_events',
    params: params5,
    method: 'POST',
  });

  useEffect(() => {
    if (params5 && params5.userIds && params5.userIds.length) {
      executeRequest5().catch((error) => {
        console.error(error);
      });
    }
  }, [params5]);

  useEffect(() => {
      if (data5) {
        setFollowJoinEvents(data5.events);
      }
  }, [data5]);

  // Rivals user join events
  const params6 = useMemo(function() {
    if (user?.rivals && user.rivals !== "[]") {
      return {
        userIds: JSON.parse(user.rivals)
      }
    } 
  }, [user?.rivals]);

  const { data: data6, loading: loading6, executeRequest: executeRequest6 } = useApiControl({
    action: '/get_join_events',
    params: params6,
    method: 'POST',
  });

  useEffect(() => {
    if (params6 && params6.userIds && params6.userIds.length) {
      executeRequest6().catch((error) => {
        console.error(error);
      });
    }
  }, [params6]);

  useEffect(() => {
      if (data6) {
        setRivalsJoinEvents(data6.events);
      }
  }, [data6]);

    // マスタータグ取得
    const { data: data7, loading: loading7, executeRequest: executeRequest7 } = useApiControl({
      action: '/get_master_tags',
      method: 'POST',
  });
  useEffect(() => {
      const localTags = localStorage.getItem('tags');
      if (localTags) {
      try {
          const parsedTags = JSON.parse(localTags);
          setMasterTags(parsedTags);
      } catch (e) {
          console.error('ローカルストレージのtagsパースエラー', e);
          executeRequest7();
      }
      } else {
          executeRequest7();
      }
  }, []);

  useEffect(() => {
      if (data7) {
          localStorage.setItem('tags', JSON.stringify(data7.tags));
          setMasterTags(data7.tags);
      }
  }, [data7]);

  const updateMasterTags = () => {
    localStorage.removeItem('tags');
    executeRequest7().catch((error) => {
        console.error(error);
    });
  };

  // user join events
  const params8 = useMemo(function() {
    if (user?.join_events	&& user.join_events !== "[]") {
      return {
        userIds: [user.id],
        includesDeleted: true,
        uncheckedCheckoutOnly: true,
      }
    } 
  }, [user?.join_events]);

  const { data: data8, loading: loading8, executeRequest: executeRequest8 } = useApiControl({
    action: '/get_join_events',
    params: params8,
    method: 'POST',
  });

  useEffect(() => {
    if (params8 && params8.userIds && params8.userIds.length) {
      executeRequest8().catch((error) => {
        console.error(error);
      });
    }
  }, [params8]);

  useEffect(() => {
      if (data8?.events) {
        const participantsSkip = data8.events.map(({ participants, ...rest }) => rest);
        setJoinEvents(participantsSkip);
        return;
      }
      setJoinEvents([]);
  }, [data8]);

  // user owners events
  const params9 = useMemo(function() {
    if (user) {
      return {
        userId: user.id,
        includesDeleted: true,
      }
    } 
  }, [user]);
  const { data: data9, loading: loading9, executeRequest: executeRequest9 } = useApiControl({
    action: '/get_owners_event',
    params: params9,
    method: 'POST',
  });

  useEffect(() => {
    if (params9) {
      executeRequest9().catch((error) => {
        console.error(error);
      });
    }
  }, [params9]);

  useEffect(() => {
    if (data9?.events && data9.events.length) {
      setMakeEvents(data9.events);
    }
  }, [data9]);

  const nextDailyPointText = useMemo(() => {
    if (!user?.daily_point_next_at) {
      return '';
    }

    const nextAt = new Date(user.daily_point_next_at);
    if (Number.isNaN(nextAt.getTime())) {
      return '';
    }

    return nextAt.toLocaleString('ja-JP', {
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }, [user?.daily_point_next_at]);

  const dailyPointBanner = isLogin && user ? (
    <Box
      sx={{
        mx: { xs: 1.5, md: 3 },
        mt: 2,
        mb: 1,
        p: 2,
        borderRadius: '16px',
        border: user.daily_point_claimable
          ? '1px solid rgba(25, 118, 210, 0.28)'
          : '1px solid rgba(0, 0, 0, 0.08)',
        background: user.daily_point_claimable
          ? 'linear-gradient(135deg, rgba(227, 242, 253, 0.96) 0%, rgba(187, 222, 251, 0.88) 100%)'
          : 'linear-gradient(135deg, rgba(250, 250, 250, 0.96) 0%, rgba(245, 245, 245, 0.92) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
          <Box sx={{ fontSize: '15px', fontWeight: 800, color: '#12344d', mb: 0.5 }}>
            {user.daily_point_claimable
              ? `本日の参加チケット ${user.daily_point_amount}枚を受け取れます`
              : '参加チケットは毎日10:00から受け取れます'}
          </Box>
          <Box sx={{ fontSize: '13px', color: 'rgba(18, 52, 77, 0.8)' }}>
            {user.daily_point_claimable
              ? '参加チケットは毎日10:00にリセットされます。翌日以降も忘れずに受け取ってください。'
              : `次回受取可能時刻: ${nextDailyPointText || '毎日10:00'}`}
          </Box>
        {dailyPointMessage ? (
          <Box sx={{ mt: 0.75, fontSize: '13px', color: '#1565c0', fontWeight: 700 }}>
            {dailyPointMessage}
          </Box>
        ) : null}
      </Box>
      {user.daily_point_claimable && (
        <Button
          variant="contained"
          onClick={claimDailyPoint}
          disabled={claimingDailyPoint}
          sx={{
            minWidth: '170px',
            fontWeight: 700,
            borderRadius: '999px',
            textTransform: 'none',
            boxShadow: 'none',
          }}
        >
          {claimingDailyPoint ? '受取中...' : `${user.daily_point_amount}枚を受け取る`}
        </Button>
      )}
    </Box>
  ) : null;

  // APIからのレスポンスがまだない場合は何も表示しない
  if (loading1 || loading2 || loading3 || loading7) {
    return (
      <>
        <BaseHeader/>
        <TopWhatGame mobile={isMobile} />
        <BetaTestLink mobile={isMobile} />
        <GuestRegisterDialog
          isVisible={isGuestRegisterDialogVisible}
          onRegistered={handleGuestRegistered}
          onClose={() => setIsGuestRegisterDialogVisible(false)}
        />
        <TopList title={"最新のbetルーム"}/>
      </>
    )
  // ユーザー依存の検索結果は待たない
  } else if (isLogin && user && events && masterTags) {
    return (
      <>
        <RoomHeader user={user}/>
        <TopWhatGame mobile={isMobile} />
        <BetaTestLink mobile={isMobile} />
        <GuestRegisterDialog
          isVisible={isGuestRegisterDialogVisible}
          onRegistered={handleGuestRegistered}
          onClose={() => setIsGuestRegisterDialogVisible(false)}
        />
        {dailyPointBanner}
        <DailyPointClaimedDialog
          isVisible={isDailyPointDialogVisible}
          onClose={() => setIsDailyPointDialogVisible(false)}
          message={dailyPointDialogMessage}
        />
        <NameSetupDialog
          isVisible={isNameSetupDialogVisible}
          initialName={user?.name}
          loading={updatingName}
          message={nameSetupMessage}
          onSave={saveNameSetup}
          onLater={closeNameSetupDialogForLater}
        />
        <TopList
          events={makeEvents}
          title={"あなたの主催ルーム！"}
          masterTags={masterTags} 
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
        <TopList
          events={joinEvents}
          title={"参加中ルーム"}
          masterTags={masterTags} 
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
        <TopList
          events={followMakeEvents}
          title={"フォローユーザーの主催ルーム！"}
          masterTags={masterTags}
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
        <TopList
          events={followJoinEvents}
          title={"フォローユーザーが参加中！"}
          masterTags={masterTags}
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
        <TopList
          events={rivalsJoinEvents}
          title={"あなたのライバルが参加中！"}
          masterTags={masterTags}
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
        <TopList
          events={events}
          title={"最新のbetルーム"}
          masterTags={masterTags}
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
      </>
    )
  } else if (!isLogin && events && masterTags){
    return (
      <>
        <NotLoginHeader/>
        <TopWhatGame mobile={isMobile} />
        <BetaTestLink mobile={isMobile} />
        <GuestRegisterDialog
          isVisible={isGuestRegisterDialogVisible}
          onRegistered={handleGuestRegistered}
          onClose={() => setIsGuestRegisterDialogVisible(false)}
        />
        <TopList
          events={events}
          title={"最新のbetルーム"}
          masterTags={masterTags}
          user={null}
          updateMasterTags={() => updateMasterTags()}
        />
      </>
    )
  }
}

export default Top
